import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useUserControl } from "../../../context/SuperAdmin/UserControlContext";

const PickVersion = () => {
  const { control } = useForm();
  const { version, changeVersion } = useUserControl();
  return (
    <Grid
      item
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Controller
        name="Organización"
        control={control}
        defaultValue={version}
        render={({ field }) => (
          <FormControl sx={{ width: "200px" }}>
            <InputLabel>Selecciona una versión</InputLabel>
            <Select
              {...field}
              onChange={(event) => {
                field.onChange(event); // Mantiene la integración con react-hook-form
                changeVersion(event); // Llama a la función externa para actualizar el estado global
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    overflowY: "auto",
                  },
                },
              }}
              label="Selecciona una suborganización"
            >
              <MenuItem key={"all"} value={"all"}>
                Todas
              </MenuItem>
              <MenuItem key={"close"} value={"close"}>
                Cerrada
              </MenuItem>
              <MenuItem key={"open"} value={"open"}>
                Abierta
              </MenuItem>
            </Select>
          </FormControl>
        )}
      />
    </Grid>
  );
};

export default PickVersion;
